<template>
  <div class="tile is-ancestor is-vertical ndc-tile">
    <div v-for="(group, index) in ndc.narrowers"
      :key="index"
      class="tile">
      <div class="tile is-parent is-4"
        v-for="child in group"
        :key="child.id">
        <router-link
          class="tile is-child box narrower"
          tag="a" :to="{ path: child.id }">
          <p class="title">{{notation(child.id)}}</p>
          <a>
            {{child.label}}
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { notation } from '../utils';

export default {
  name: 'NdcTitle',
  props: [
    'ndc',
  ],
  data() {
    return {
    };
  },
  methods: {
    notation,
  },
};
</script>

<style scoped>
.ndc-tile {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.narrower:hover {
  background-color: hsl(217, 71%, 53%);
}
.narrower:hover p {
  color: white;
}
.narrower:hover a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/NdcTile.vue